(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4933],{

/***/ 28262:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ingresar",
      function () {
        return __webpack_require__(33160);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 33160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ SignIn; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(42838);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(45680);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/index.ts + 3 modules
var utils = __webpack_require__(8881);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/FormComponents.ts
var FormComponents = __webpack_require__(61912);
// EXTERNAL MODULE: ./src/components/PageWrapper.tsx
var PageWrapper = __webpack_require__(73362);
// EXTERNAL MODULE: ./src/services/firebase.ts + 1 modules
var firebase = __webpack_require__(45997);
// EXTERNAL MODULE: ./src/hooks/useAuth.tsx + 4 modules
var useAuth = __webpack_require__(21566);
// EXTERNAL MODULE: ./src/hooks/useOrderState.tsx
var useOrderState = __webpack_require__(778);
// EXTERNAL MODULE: ./src/hooks/useSegment.ts
var useSegment = __webpack_require__(59945);
// EXTERNAL MODULE: ./src/screens/signIn/styles.ts
var styles = __webpack_require__(514);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/MenuItem/MenuItem.js + 1 modules
var MenuItem = __webpack_require__(31538);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(61702);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(70754);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./src/hooks/useMekiState.tsx + 1 modules
var useMekiState = __webpack_require__(48231);
// EXTERNAL MODULE: ../../node_modules/firebase/auth/dist/index.esm.js + 2 modules
var dist_index_esm = __webpack_require__(2498);
// EXTERNAL MODULE: ./src/queries/authCode/mutations/createAuthCode.ts
var createAuthCode = __webpack_require__(82688);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(50319);
// EXTERNAL MODULE: ./node_modules/react-device-detect/main.js
var main = __webpack_require__(59359);
// EXTERNAL MODULE: ./src/services/sentry.ts
var sentry = __webpack_require__(52353);
// EXTERNAL MODULE: ./src/services/openreplay.ts
var openreplay = __webpack_require__(92268);
// EXTERNAL MODULE: ./src/components/Modal.tsx
var Modal = __webpack_require__(43354);
// EXTERNAL MODULE: ../../node_modules/@passwordless-id/webauthn/dist/esm/index.js + 6 modules
var esm = __webpack_require__(36389);
// EXTERNAL MODULE: ./src/services/biometricLogin.ts
var biometricLogin = __webpack_require__(56665);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/utils/validators/biometricBrowserValidator.ts + 1 modules
var biometricBrowserValidator = __webpack_require__(93213);
// EXTERNAL MODULE: ./src/components/Header/SimpleHeader.tsx + 1 modules
var SimpleHeader = __webpack_require__(45629);
// EXTERNAL MODULE: ./src/hooks/useEventTracking.tsx + 1 modules
var useEventTracking = __webpack_require__(66630);
// EXTERNAL MODULE: ./src/validators/Events/Screen.ts
var Screen = __webpack_require__(42101);
// EXTERNAL MODULE: ./src/validators/Events/Interaction.ts
var Interaction = __webpack_require__(22656);
// EXTERNAL MODULE: ./src/validators/Events/Automatic.ts
var Automatic = __webpack_require__(21963);
// EXTERNAL MODULE: ./src/validators/Events/Error.ts
var Events_Error = __webpack_require__(64785);
;// CONCATENATED MODULE: ./src/screens/signIn/index.tsx





































var phoneCodes = function() {
    return __webpack_require__.e(/* import() */ 3927).then(__webpack_require__.t.bind(__webpack_require__, 73927, 19)).then(function(mod) {
        return mod.phoneCodes;
    });
};
var device = main/* mobileModel */.N7 === "none" ? "".concat(main/* osName */.BF, " ").concat(main/* osVersion */.MM) : "".concat(main/* mobileModel */.N7, " ").concat(main/* osName */.BF, " ").concat(main/* osVersion */.MM);
var BiometricProcessType;
(function(BiometricProcessType) {
    BiometricProcessType["IDLE"] = "IDLE";
    BiometricProcessType["LOADING"] = "LOADING";
    BiometricProcessType["SUCCESS"] = "SUCCESS";
    BiometricProcessType["ERROR"] = "ERROR";
})(BiometricProcessType || (BiometricProcessType = {}));
var TAG = "[SIGN_IN_SCREEN]";
function NewSignIn() {
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var debugTrack = (0,useSegment/* useSegment */.K)().debugTrack;
    var track = (0,useEventTracking/* useEventTracking */.A)().track;
    var ref2 = (0,openreplay/* useOpenReplayTracking */.WK)(), trackIssue = ref2.trackIssue, trackEvent = ref2.trackEvent;
    var ref3 = (0,useAuth/* useAuth */.a)(), firebaseUser = ref3.firebaseUser, appUser = ref3.appUser, authLoading = ref3.loading;
    var showError = (0,firebase/* useShowFirebaseAuthError */.NM)().showError;
    var ref4 = (0,useOrderState/* useOrderState */.h)(), orderUuid = ref4.orderUuid, setOrderUuid = ref4.setOrderUuid;
    var contactWrittenEventSent = (0,react.useRef)(false);
    var ref5 = (0,useMekiState/* useMekiState */.c)(), setRegistryFrom = ref5.setRegistryFrom, typeOfSingin = ref5.typeOfSingin, setTypeOfSingin = ref5.setTypeOfSingin, referralCode = ref5.referralCode;
    track(Screen/* ScreenEventType.ScreenLogIn */.O.ScreenLogIn);
    var ref6 = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            userInput: ""
        }
    }), register = ref6.register, handleSubmit = ref6.handleSubmit, watch = ref6.watch, setValue = ref6.setValue, errors = ref6.formState.errors;
    var userInput = watch("userInput");
    var userInputRef = (0,react.useRef)(userInput);
    var ref7 = (0,react.useState)("\uD83C\uDDE8\uD83C\uDDF1 +56"), phonePrefix = ref7[0], setPhonePrefix = ref7[1];
    var ref8 = (0,react.useState)([
        {
            name: "Chile",
            icon: "\uD83C\uDDE8\uD83C\uDDF1",
            prefix: "+56"
        }, 
    ]), phoneCodeList = ref8[0], setPhoneCodeList = ref8[1];
    var ref9 = (0,react.useState)(false), phoneLoading = ref9[0], setPhoneLoading = ref9[1];
    var ref10 = (0,react.useState)(null), alertModal = ref10[0], setAlertModal = ref10[1];
    var ref11 = (0,react.useState)(BiometricProcessType.IDLE), biometricProcessStatus = ref11[0], setBiometricProcessStatus = ref11[1];
    var ref12 = (0,react.useState)(false), quickDisableButton = ref12[0], setQuickDisableButton = ref12[1];
    var ref13 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)((0,createAuthCode/* CreateAuthCodeMutation */.V)()), 2), sendAuthCode = ref13[0], ref14 = ref13[1], emailLoading = ref14.loading;
    var hasGeneretedCaptcha = (0,react.useRef)(false);
    var generateRecaptcha = function() {
        window.recaptchaVerifier = new dist_index_esm/* RecaptchaVerifier */.lI("sign-in-button", {
            size: "invisible",
            callback: function(response) {
                utils/* Console.log */.Mn.log({
                    msg: TAG + "reCAPTCHA solved, allow signInWithPhoneNumber",
                    response: response
                });
            }
        }, (0,firebase/* getFirebaseAuth */.yL)());
    };
    var handleKeyDown = function(event) {
        if (event.key === "Backspace" && (userInput === "+56" || userInput === "56") && typeOfSingin === "phone") {
            setValue("userInput", "");
        }
    };
    var handleSelectChange = (0,react.useCallback)(function(e) {
        setPhonePrefix(String(e.target.value));
    }, [
        setPhonePrefix
    ]);
    var signInWithCustomFirebaseToken = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(customToken, userData) {
            var userCredential, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!customToken) return [
                            3,
                            4
                        ];
                        debugTrack("AUTH", "sign in with custom token", {});
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0,dist_index_esm/* signInWithCustomToken */._p)((0,firebase/* getFirebaseAuth */.yL)(), customToken)
                        ];
                    case 2:
                        userCredential = _state.sent();
                        utils/* Console.log */.Mn.log({
                            msg: TAG + "Firebase login",
                            user: userCredential.user
                        });
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        debugTrack("AUTH", "error on firebase custom token sign in", {
                            email: userData.email,
                            phone: userData.phone
                        });
                        void (0,sentry/* getSentry */.$)().then(function(Sentry) {
                            Sentry.captureException(error);
                        });
                        void trackIssue("[NEW_REGISTRY_ADITIONAL_INFORMATION_SCREEN_ISSUE]: Firebase User couldn't sign in", error);
                        utils/* Console.log */.Mn.log({
                            msg: TAG + "Firebase User couldn't sign in"
                        });
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(customToken, userData) {
            return _ref.apply(this, arguments);
        };
    }(), [
        debugTrack,
        trackIssue
    ]);
    var emailSingIn = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(biometricFailed) {
            var response, message, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        debugTrack("AUTH", "send code", {
                            type: "email",
                            userInput: userInput
                        });
                        setRegistryFrom({
                            name: "",
                            lastName: "",
                            email: userInput,
                            phonePrefix: "",
                            phone: "",
                            rut: "",
                            code: "",
                            source: ""
                        });
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            6
                        ]);
                        return [
                            4,
                            sendAuthCode({
                                variables: {
                                    params: {
                                        email: userInput,
                                        device: device,
                                        browser: main/* browserName */.KC
                                    }
                                }
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        message = response.data.createAuthCode.msg;
                        if (message === "Email send successfully") {
                            void trackEvent(TAG + "Email send successfully");
                            utils/* Console.log */.Mn.log({
                                msg: TAG + "email sent",
                                message: message
                            });
                            track(Automatic/* AutomaticEventTypes.SessionVerificationCodeSent */.j5.SessionVerificationCodeSent, {
                                type: "email"
                            });
                            debugTrack("AUTH", "sign in next", {
                                typeOfSingin: typeOfSingin,
                                userInput: userInput
                            });
                            void router.push((0,utils/* getRoute */.Bv)("verifyCode", {
                                biometricFailed: (biometricFailed === null || biometricFailed === void 0 ? void 0 : biometricFailed.toString()) || "false"
                            }));
                            return [
                                2
                            ];
                        }
                        if (message === "Error sending email") {
                            throw new Error("Email not sent");
                        }
                        return [
                            3,
                            6
                        ];
                    case 3:
                        error = _state.sent();
                        return [
                            4,
                            (0,sentry/* getSentry */.$)().then(function(Sentry) {
                                Sentry.captureException(error);
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            4,
                            trackIssue("[SIGN_IN_SCREEN_ISSUE]: Error email not sent", error)
                        ];
                    case 5:
                        _state.sent();
                        utils/* Console.log */.Mn.log({
                            msg: TAG + "Error; email not sent"
                        });
                        setAlertModal({
                            title: "No pudimos enviar el correo",
                            content: "Prueba iniciando sesi\xf3n con tu n\xfamero de tel\xe9fono"
                        });
                        debugTrack("AUTH", "send code error", {
                            type: "email",
                            userInput: userInput
                        });
                        track(Events_Error/* ErrorEventTypes.SessionVerificationCodeNotSent */.rf.SessionVerificationCodeNotSent, {
                            type: typeOfSingin,
                            phone_number: null,
                            email: userInput,
                            error: error,
                            is_auth_error: (0,firebase/* isAuthError */.f1)(error)
                        });
                        return [
                            2
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function(biometricFailed) {
            return _ref.apply(this, arguments);
        };
    }(), [
        debugTrack,
        device,
        router,
        sendAuthCode,
        setRegistryFrom,
        track,
        trackEvent,
        trackIssue,
        typeOfSingin,
        userInput, 
    ]);
    var phoneSingIn = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(biometricFailed) {
            var phoneNumber, phoneWithoutSpaces, confirmationResult, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        phoneNumber = phonePrefix.split(" ")[1] + " " + userInput;
                        debugTrack("AUTH", "send code", {
                            type: "phone",
                            phoneNumber: phoneNumber
                        });
                        utils/* Console.log */.Mn.log({
                            msg: TAG + "Singin con numero de tel\xe9fono",
                            phoneNumber: phoneNumber
                        });
                        setRegistryFrom({
                            name: "",
                            lastName: "",
                            email: "",
                            phonePrefix: phonePrefix,
                            phone: phoneNumber,
                            rut: "",
                            code: "",
                            source: ""
                        });
                        if (!hasGeneretedCaptcha.current) {
                            generateRecaptcha();
                            hasGeneretedCaptcha.current = true;
                        } else {
                            if (window.recaptchaWidgetId === undefined) {
                                void window.recaptchaVerifier.render().then(function(widgetId) {
                                    window.recaptchaWidgetId = widgetId;
                                    window.grecaptcha.reset(widgetId);
                                });
                            } else {
                                window.grecaptcha.reset(window.recaptchaWidgetId);
                            }
                        }
                        phoneWithoutSpaces = phoneNumber.split(" ")[0] + phoneNumber.split(" ")[1];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            9
                        ]);
                        setPhoneLoading(true);
                        return [
                            4,
                            (0,dist_index_esm/* signInWithPhoneNumber */.$g)((0,firebase/* getFirebaseAuth */.yL)(), phoneWithoutSpaces, window.recaptchaVerifier)
                        ];
                    case 2:
                        confirmationResult = _state.sent();
                        // SMS sent.
                        window.confirmationResult = confirmationResult;
                        void trackEvent(TAG + "SMS send successfully");
                        utils/* Console.log */.Mn.log({
                            msg: TAG + "SMS sent",
                            confirmationResult: confirmationResult
                        });
                        track(Automatic/* AutomaticEventTypes.SessionVerificationCodeSent */.j5.SessionVerificationCodeSent, {
                            type: "phone"
                        });
                        debugTrack("AUTH", "sign in next", {
                            typeOfSingin: typeOfSingin,
                            userInput: userInput
                        });
                        void router.push((0,utils/* getRoute */.Bv)("verifyCode", {
                            biometricFailed: (biometricFailed === null || biometricFailed === void 0 ? void 0 : biometricFailed.toString()) || "false"
                        }));
                        setPhoneLoading(false);
                        return [
                            2
                        ];
                    case 3:
                        error = _state.sent();
                        debugTrack("AUTH", "send code error", {
                            type: "phone",
                            phoneNumber: phoneNumber
                        });
                        if (!(0,firebase/* isAuthError */.f1)(error)) return [
                            3,
                            5
                        ];
                        showError(error);
                        return [
                            4,
                            trackIssue("[SIGN_IN_SCREEN_ISSUE]: Firebase error SMS not sent", error)
                        ];
                    case 4:
                        _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 5:
                        return [
                            4,
                            trackIssue("[SIGN_IN_SCREEN_ISSUE]: Error SMS not sent", error)
                        ];
                    case 6:
                        _state.sent();
                        _state.label = 7;
                    case 7:
                        track(Events_Error/* ErrorEventTypes.SessionVerificationCodeNotSent */.rf.SessionVerificationCodeNotSent, {
                            type: typeOfSingin,
                            phone_number: phoneNumber,
                            email: null,
                            error: error,
                            is_auth_error: (0,firebase/* isAuthError */.f1)(error)
                        });
                        return [
                            4,
                            (0,sentry/* getSentry */.$)().then(function(Sentry) {
                                Sentry.captureException(error);
                            })
                        ];
                    case 8:
                        _state.sent();
                        utils/* Console.log */.Mn.log({
                            msg: TAG + "Error; SMS not sent"
                        });
                        setPhoneLoading(false);
                        return [
                            2
                        ];
                    case 9:
                        return [
                            2
                        ];
                }
            });
        });
        return function(biometricFailed) {
            return _ref.apply(this, arguments);
        };
    }(), [
        debugTrack,
        phonePrefix,
        router,
        setRegistryFrom,
        showError,
        track,
        trackEvent,
        trackIssue,
        typeOfSingin,
        userInput, 
    ]);
    var simpleSignIn = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(biometricFailed) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(typeOfSingin === "email")) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            emailSingIn(biometricFailed)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                    case 2:
                        if (!(typeOfSingin === "phone")) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            phoneSingIn(biometricFailed)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                    case 4:
                        debugTrack("AUTH", "ignore signin next button", {
                            typeOfSingin: typeOfSingin,
                            userInput: userInput,
                            emailLoading: emailLoading,
                            phoneLoading: phoneLoading
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function(biometricFailed) {
            return _ref.apply(this, arguments);
        };
    }(), [
        track,
        typeOfSingin,
        debugTrack,
        userInput,
        emailLoading,
        phoneLoading,
        emailSingIn,
        phoneSingIn, 
    ]);
    var onSubmit = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var isAvailableBiometric, userIdentifier, ref, userData, userExists, ref1, userCredentials, ref2, challenge, login, ref3, verifyLogin, error, error1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    track(Interaction/* InteractionEventTypes.ClickNext */.PA.ClickNext, {
                        location: "login"
                    });
                    if (quickDisableButton) return [
                        2
                    ];
                    setQuickDisableButton(true);
                    if (emailLoading && typeOfSingin === "email" || phoneLoading && typeOfSingin === "phone") {
                        utils/* Console.log */.Mn.log({
                            msg: "DEBUG Block due emailLoading",
                            emailLoading: emailLoading,
                            phoneLoading: phoneLoading,
                            typeOfSingin: typeOfSingin
                        });
                        debugTrack("AUTH", "block signin next button", {
                            emailLoading: emailLoading,
                            phoneLoading: phoneLoading,
                            userInput: userInput
                        });
                        return [
                            2
                        ];
                    }
                    isAvailableBiometric = !!window.PublicKeyCredential && (0,biometricBrowserValidator/* browserIsValidForBiometric */.E)();
                    userIdentifier = typeOfSingin === "email" ? userInput : phonePrefix.split(" ")[1] + userInput;
                    return [
                        4,
                        biometricLogin/* UserApi.get */.W.get("/".concat(userIdentifier))
                    ];
                case 1:
                    ref = _state.sent(), userData = ref.data;
                    utils/* Console.log */.Mn.log({
                        msg: "DEBUG userData",
                        userData: userData
                    });
                    debugTrack("AUTH", "userData", {
                        userData: userData,
                        isAvailableBiometric: isAvailableBiometric
                    });
                    userExists = userData && userData.userId !== null;
                    if (!(isAvailableBiometric && userExists)) return [
                        3,
                        18
                    ];
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        15,
                        ,
                        17
                    ]);
                    return [
                        4,
                        biometricLogin/* BiometricApi.get */.P.get("/credentials/".concat(userData.email))
                    ];
                case 3:
                    ref1 = _state.sent(), userCredentials = ref1.data;
                    utils/* Console.log */.Mn.log({
                        msg: "DEBUG user credentials ids",
                        userCredentials: userCredentials
                    });
                    debugTrack("AUTH", "user credentials ids", {
                        userCredentials: userCredentials
                    });
                    if (!((userCredentials === null || userCredentials === void 0 ? void 0 : userCredentials.credentialsIds.length) > 0)) return [
                        3,
                        12
                    ];
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        9,
                        ,
                        11
                    ]);
                    setBiometricProcessStatus(BiometricProcessType.LOADING);
                    return [
                        4,
                        biometricLogin/* BiometricApi.get */.P.get("/challenge/".concat(userData.email))
                    ];
                case 5:
                    ref2 = _state.sent(), challenge = ref2.data;
                    utils/* Console.log */.Mn.log({
                        msg: "DEBUG challenge",
                        challenge: challenge
                    });
                    debugTrack("AUTH", "DEBUG challenge", {
                        challenge: challenge.challenge
                    });
                    return [
                        4,
                        esm/* client.authenticate */.Lp.authenticate(userCredentials.credentialsIds, challenge.challenge, {
                            authenticatorType: "auto",
                            userVerification: "required"
                        })
                    ];
                case 6:
                    login = _state.sent();
                    utils/* Console.log */.Mn.log({
                        msg: "DEBUG verify biometric login",
                        login: login,
                        origin: window.location.origin,
                        userEmail: userData.email
                    });
                    debugTrack("AUTH", "DEBUG verify biometric login", {
                        login: login,
                        origin: window.location.origin,
                        userEmail: userData.email
                    });
                    track(Automatic/* AutomaticEventTypes.SessionBiometricLoginAttempt */.j5.SessionBiometricLoginAttempt);
                    return [
                        4,
                        biometricLogin/* BiometricApi.post */.P.post("/login", {
                            authentication: login,
                            origin: window.location.origin,
                            userEmail: userData.email
                        })
                    ];
                case 7:
                    ref3 = _state.sent(), verifyLogin = ref3.data;
                    utils/* Console.log */.Mn.log({
                        msg: "DEBUG verifyLogin",
                        verifyLogin: verifyLogin
                    });
                    debugTrack("AUTH", "DEBUG verifyLogin", {
                        verifyLogin: verifyLogin
                    });
                    setBiometricProcessStatus(BiometricProcessType.SUCCESS);
                    track(Automatic/* AutomaticEventTypes.SessionBiometricLoginSuccess */.j5.SessionBiometricLoginSuccess);
                    return [
                        4,
                        signInWithCustomFirebaseToken(verifyLogin.loginCustomToken, userData)
                    ];
                case 8:
                    _state.sent();
                    return [
                        3,
                        11
                    ];
                case 9:
                    error = _state.sent();
                    if ((0,_instanceof/* default */.Z)(error, DOMException)) {
                        utils/* Console.log */.Mn.log({
                            msg: "DEBUG error",
                            error: error
                        });
                        debugTrack("AUTH", "ERROR biometric login (DOMException)", {
                            error: error.message,
                            userEmail: userData.email
                        });
                    }
                    utils/* Console.log */.Mn.log({
                        msg: "DEBUG error on biometric login"
                    });
                    debugTrack("AUTH", "ERROR  biometric login", {
                        error: error,
                        userEmail: userData.email
                    });
                    setQuickDisableButton(false);
                    track(Events_Error/* ErrorEventTypes.SessionBiometricLogin */.rf.SessionBiometricLogin, {
                        error: error
                    });
                    setBiometricProcessStatus(BiometricProcessType.ERROR);
                    setTimeout(function() {
                        setBiometricProcessStatus(BiometricProcessType.IDLE);
                    }, 2000);
                    return [
                        4,
                        simpleSignIn(true)
                    ];
                case 10:
                    _state.sent();
                    return [
                        2
                    ];
                case 11:
                    return [
                        3,
                        14
                    ];
                case 12:
                    setQuickDisableButton(false);
                    setBiometricProcessStatus(BiometricProcessType.IDLE);
                    return [
                        4,
                        simpleSignIn()
                    ];
                case 13:
                    _state.sent();
                    return [
                        2
                    ];
                case 14:
                    return [
                        3,
                        17
                    ];
                case 15:
                    error1 = _state.sent();
                    utils/* Console.log */.Mn.log({
                        msg: "DEBUG error on biometric login"
                    });
                    debugTrack("AUTH", "ERROR  biometric login", {
                        error: error1,
                        userEmail: userData.email
                    });
                    setQuickDisableButton(false);
                    track(Events_Error/* ErrorEventTypes.SessionBiometricLogin */.rf.SessionBiometricLogin, {
                        error: error1
                    });
                    setBiometricProcessStatus(BiometricProcessType.ERROR);
                    setBiometricProcessStatus(BiometricProcessType.IDLE);
                    return [
                        4,
                        simpleSignIn(true)
                    ];
                case 16:
                    _state.sent();
                    return [
                        2
                    ];
                case 17:
                    return [
                        3,
                        20
                    ];
                case 18:
                    setQuickDisableButton(false);
                    setBiometricProcessStatus(BiometricProcessType.IDLE);
                    return [
                        4,
                        simpleSignIn()
                    ];
                case 19:
                    _state.sent();
                    return [
                        2
                    ];
                case 20:
                    return [
                        2
                    ];
            }
        });
    }), [
        quickDisableButton,
        emailLoading,
        typeOfSingin,
        phoneLoading,
        userInput,
        phonePrefix,
        debugTrack,
        track,
        signInWithCustomFirebaseToken,
        simpleSignIn, 
    ]);
    (0,react.useEffect)(function() {
        // void track('log in start');
        setTypeOfSingin("unset");
    }, [
        track,
        setTypeOfSingin
    ]);
    (0,react.useEffect)(function validateEmailorPhone() {
        if (typeOfSingin === "phone" && /^\+?56/.exec(userInputRef.current)) {
            return;
        }
        if (((userInput === null || userInput === void 0 ? void 0 : userInput.length) < 2 && !userInput.startsWith("+") || (userInput === null || userInput === void 0 ? void 0 : userInput.length) < 3 && userInput.startsWith("+")) && typeOfSingin !== "unset") {
            debugTrack("AUTH", "set type of input", {
                userInput: userInput,
                type: "unset"
            });
            setTypeOfSingin("unset");
            return;
        }
        if ((userInput === null || userInput === void 0 ? void 0 : userInput.length) < 3) return;
        var isNumber = /^\+?\d+$/.test(userInput);
        if (isNumber && typeOfSingin !== "phone") {
            setTypeOfSingin("phone");
            debugTrack("AUTH", "set type of input", {
                userInput: userInput,
                type: "phone"
            });
            return;
        }
        if (!isNumber && typeOfSingin !== "email") {
            setTypeOfSingin("email");
            debugTrack("AUTH", "set type of input", {
                userInput: userInput,
                type: "email"
            });
            return;
        }
    }, [
        userInput,
        setTypeOfSingin,
        typeOfSingin,
        debugTrack
    ]);
    (0,react.useEffect)(function handleAmplitudeEventOnInput() {
        if (typeOfSingin === "unset") {
            contactWrittenEventSent.current = false;
            return;
        }
        if (!contactWrittenEventSent.current) {
            if (typeOfSingin === "phone" && userInput.length >= 9 || typeOfSingin === "email" && userInput.length >= 5) {
                track(Interaction/* InteractionEventTypes.LoginContactWritten */.PA.LoginContactWritten, {
                    type: typeOfSingin
                });
                contactWrittenEventSent.current = true;
            }
        }
    }, [
        contactWrittenEventSent,
        typeOfSingin,
        userInput
    ]);
    (0,react.useEffect)(function checkLoginAndRedirect() {
        if (authLoading) return;
        var redirect = router.query.redirect;
        utils/* Console.log */.Mn.log({
            msg: TAG + "CheckLoginAndRedirect effect: validate auth",
            firebaseUser: firebaseUser,
            appUser: appUser,
            orderUuid: orderUuid,
            redirect: redirect,
            authLoading: authLoading
        });
        if (!firebaseUser) {
            utils/* Console.log */.Mn.log({
                msg: TAG + " CheckLoginAndRedirect no firebase user"
            });
            return;
        }
        if (appUser) {
            utils/* Console.log */.Mn.log({
                msg: TAG + " Redirect from signin",
                to: redirect !== null && redirect !== void 0 ? redirect : (0,utils/* getRoute */.Bv)("home"),
                redirect: redirect,
                firebaseUser: firebaseUser,
                appUser: appUser,
                router: router
            });
            // void track('log in succeed', { referralCode });
            debugTrack("AUTH", "sign in next", {
                typeOfSingin: typeOfSingin,
                userInput: userInput
            });
            if (!redirect) {
                return void router.replace((0,utils/* getRoute */.Bv)("home", (referralCode === null || referralCode === void 0 ? void 0 : referralCode.length) > 0 ? {
                    codigo: referralCode
                } : {}));
            }
            return void router.replace({
                pathname: redirect,
                query: (0,utils/* removeUndefineds */.ox)({
                    codigo: (referralCode === null || referralCode === void 0 ? void 0 : referralCode.length) > 0 ? referralCode : undefined
                })
            });
        }
        utils/* Console.log */.Mn.log({
            msg: TAG + " Redirect from signin to register cause no appuser",
            to: (0,utils/* getRoute */.Bv)("register"),
            firebaseUser: firebaseUser,
            appUser: appUser
        });
        debugTrack("AUTH", "sign in next", {
            typeOfSingin: typeOfSingin,
            userInput: userInput
        });
        void router.push((0,utils/* getRoute */.Bv)("register"));
    }, [
        router,
        setOrderUuid,
        authLoading,
        firebaseUser,
        appUser,
        track,
        referralCode,
        debugTrack,
        typeOfSingin,
        userInput,
        setTypeOfSingin, 
    ]);
    (0,react.useEffect)(function updateUserInputRefValue() {
        userInputRef.current = userInput;
    }, [
        userInput
    ]);
    var ref15;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageWrapper/* BackgroundGlobalStyle */.m, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleHeader/* SimpleHeader */.A, {
                homeButtonColor: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageWrapper/* PageWrapper */.F, {
                disableMobilePadding: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormComponents/* FormMainCard */.sh, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormComponents/* Form */.l0, {
                        onSubmit: handleSubmit(onSubmit),
                        noValidate: true,
                        id: "my-form",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormComponents/* TitleContainer */.c7, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormComponents/* TitleTypography */.dP, {
                                        children: "\xbfCu\xe1l es tu tel\xe9fono celular o tu correo electr\xf3nico?"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormComponents/* SubtitleTypography */.LE, {
                                        children: "Te enviaremos un c\xf3digo de verificaci\xf3n."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormComponents/* ContentContainer */.OO, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormComponents/* InputDiv */.Xl, {
                                        children: [
                                            typeOfSingin === "phone" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        id: "sign-in-button"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormComponents/* PhonePrefixSelect */.ap, {
                                                        variant: "outlined",
                                                        size: "small",
                                                        value: phonePrefix,
                                                        renderValue: function(selected) {
                                                            return selected;
                                                        },
                                                        onChange: handleSelectChange,
                                                        onOpen: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                                            var codes;
                                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                                switch(_state.label){
                                                                    case 0:
                                                                        return [
                                                                            4,
                                                                            phoneCodes()
                                                                        ];
                                                                    case 1:
                                                                        codes = _state.sent();
                                                                        setPhoneCodeList(codes);
                                                                        return [
                                                                            2
                                                                        ];
                                                                }
                                                            });
                                                        }),
                                                        children: phoneCodeList === null || phoneCodeList === void 0 ? void 0 : phoneCodeList.map(function(option) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                                                                value: "".concat(option.icon, " ").concat(option.prefix),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* IconListItemText */.S0, {
                                                                        children: option.icon
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                                                        children: option.name
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                        variant: "body2",
                                                                        color: "text.secondary",
                                                                        children: option.prefix
                                                                    })
                                                                ]
                                                            }, option.name);
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormComponents/* TextInput */.oi, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                type: "email"
                                            }, register("userInput", {
                                                required: "Debes ingresar tu correo o tel\xe9fono",
                                                onChange: function(event) {
                                                    return setValue("userInput", event.target.value.toLowerCase().replace(/\s/g, ""));
                                                },
                                                validate: function(value) {
                                                    if (typeOfSingin == "phone") {
                                                        if (phonePrefix.split(" ")[1] === "+56") {
                                                            if (value.length < 9) {
                                                                return "Tel\xe9fono incompleto";
                                                            }
                                                            if (value.length > 9) {
                                                                return "Tel\xe9fono muy largo";
                                                            } else {
                                                                if (phonePrefix.split(" ")[1].length + value.length > 15) {
                                                                    return "Tel\xe9fono muy largo";
                                                                }
                                                            }
                                                        } else {
                                                            if (phonePrefix.split(" ")[1].length + value.length > 15) {
                                                                return "Tel\xe9fono muy largo";
                                                            }
                                                        }
                                                    } else {
                                                        if (/^([a-zA-Z0-9_\-+.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/.exec(userInput)) {
                                                            return true;
                                                        } else {
                                                            return "Este email est\xe1 incompleto \uD83E\uDD37‍♀";
                                                        }
                                                    }
                                                }
                                            })), {
                                                label: typeOfSingin === "unset" ? "Ingresa tu tel\xe9fono o correo" : typeOfSingin === "email" ? "Correo electr\xf3nico" : "N\xfamero de tel\xe9fono",
                                                value: typeOfSingin === "phone" ? userInput.replace(/^\+?56/, "") : userInput,
                                                error: Boolean((ref = errors.userInput) === null || ref === void 0 ? void 0 : ref.message),
                                                helperText: (ref15 = (ref1 = errors.userInput) === null || ref1 === void 0 ? void 0 : ref1.message) !== null && ref15 !== void 0 ? ref15 : " ",
                                                onKeyDown: handleKeyDown
                                            }))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormComponents/* SubmitButton */.Mm, {
                                        type: "submit",
                                        form: "my-form",
                                        disabled: quickDisableButton || authLoading || biometricProcessStatus === BiometricProcessType.LOADING || phoneLoading && typeOfSingin === "phone" || emailLoading && typeOfSingin === "email",
                                        children: "Siguiente"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            alertModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* AlertModal */.VF, {
                open: true,
                title: alertModal.title,
                setOpen: function(open) {
                    return !open && setAlertModal(null);
                },
                content: alertModal.content,
                actions: [
                    {
                        text: "Ok",
                        onActionClick: function() {
                            return setAlertModal(null);
                        },
                        variant: "contained"
                    }, 
                ]
            }),
            (phoneLoading || emailLoading) && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* GreyOverlay */.fD, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* LoaderComponentContainer */.Mq, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* AskDataTypography */.vt, {
                            children: phoneLoading && typeOfSingin === "phone" ? "Enviando SMS..." : "Enviando correo..."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                            size: 30,
                            color: "info"
                        })
                    ]
                })
            }),
            biometricProcessStatus !== BiometricProcessType.IDLE && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* GreyOverlay */.fD, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* LoaderComponentContainer */.Mq, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* AskDataTypography */.vt, {
                            children: biometricProcessStatus === BiometricProcessType.LOADING ? "Solicitando biometr\xeda..." : biometricProcessStatus === BiometricProcessType.SUCCESS ? "Iniciando sesi\xf3n..." : "Error al obtener biometr\xeda"
                        }),
                        (biometricProcessStatus === BiometricProcessType.LOADING || biometricProcessStatus === BiometricProcessType.SUCCESS) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                            size: 30,
                            color: "info"
                        }),
                        biometricProcessStatus === BiometricProcessType.ERROR && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/assets/images/warningIcon.png",
                            alt: "Check",
                            width: 30,
                            height: 30
                        })
                    ]
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/seo.tsx
var seo = __webpack_require__(39425);
;// CONCATENATED MODULE: ./pages/ingresar/index.tsx



function SignIn() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo/* SEOHead */.R, {
                title: "Meki \xb7 Ingresar"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewSignIn, {})
        ]
    });
}


/***/ }),

/***/ 61912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LE": function() { return /* binding */ SubtitleTypography; },
/* harmony export */   "Mm": function() { return /* binding */ SubmitButton; },
/* harmony export */   "OO": function() { return /* binding */ ContentContainer; },
/* harmony export */   "Xl": function() { return /* binding */ InputDiv; },
/* harmony export */   "ap": function() { return /* binding */ PhonePrefixSelect; },
/* harmony export */   "c7": function() { return /* binding */ TitleContainer; },
/* harmony export */   "dP": function() { return /* binding */ TitleTypography; },
/* harmony export */   "l0": function() { return /* binding */ Form; },
/* harmony export */   "oi": function() { return /* binding */ TextInput; },
/* harmony export */   "sh": function() { return /* binding */ FormMainCard; },
/* harmony export */   "up": function() { return /* binding */ UrlSpan; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47842);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30120);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29630);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67836);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(53442);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26993);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13264);
/* harmony import */ var _BaseStyles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8347);




var FormMainCard = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_BaseStyles__WEBPACK_IMPORTED_MODULE_0__/* .MainCard */ .A)(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        maxWidth: "100%",
        minHeight: "100dvh",
        borderRadius: 0,
        padding: "40px 24px 32px 24px",
        overflow: "hidden"
    }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, theme.breakpoints.up("sm"), {
        padding: "96px 16px 32px 16px"
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, theme.breakpoints.up("md"), {
        maxWidth: "800px",
        minHeight: "620px",
        padding: "56px",
        borderRadius: "10px"
    }), _obj;
});
var Form = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("form")({
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    maxWidth: "450px",
    width: "100%",
    alignItems: "center"
});
var TitleContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
    var theme = param.theme, width = param.width;
    return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        width: width || "100%"
    }, theme.breakpoints.up("sm"), {
        padding: "0 24px"
    });
});
var TitleTypography = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
    var theme = param.theme;
    return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        fontWeight: 500,
        fontSize: "16px",
        lineHeight: "24px",
        letterSpacing: "0.15px",
        color: theme.palette.text.primary
    }, theme.breakpoints.up("sm"), {
        fontSize: "24px",
        lineHeight: "36px",
        textAlign: "center"
    });
});
var SubtitleTypography = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
    var theme = param.theme;
    return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        fontWeight: 400,
        fontSize: "14px",
        lineHeight: "21px",
        letterSpacing: "0.15px",
        color: theme.palette.text.secondary
    }, theme.breakpoints.up("sm"), {
        fontSize: "16px",
        lineHeight: "24px",
        textAlign: "center"
    });
});
var ContentContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
    var theme = param.theme;
    return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        width: "100%"
    }, theme.breakpoints.up("sm"), {
        padding: "0 24px",
        gap: "24px"
    });
});
var InputDiv = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div")({
    display: "flex",
    flexDirection: "row"
});
var TextInput = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
    width: "100%",
    "& .MuiOutlinedInput-root": {
        height: "48px"
    },
    "& .MuiInputLabel-root": {
        top: "-4px"
    },
    "& .MuiFormHelperText-root": {
        minHeight: "20px"
    },
    "& input:-webkit-autofill": {
        height: "14px"
    }
});
var PhonePrefixSelect = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    width: "150px",
    marginRight: "10px",
    height: "48px"
});
var SubmitButton = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
    padding: "9px 60px",
    backgroundColor: "#0A7ABE",
    borderRadius: "100px",
    border: "none",
    transition: "all 0.3s ease-in-out",
    color: "white",
    "&:hover": {
        backgroundColor: "#0A7ABE"
    },
    "&:disabled": {
        backgroundColor: "#EAEAEA",
        color: "#AFAFAF"
    },
    textTransform: "none",
    fontWeight: 400,
    lineHeight: "24px",
    letterSpacing: "0.15px",
    fontSize: "16px"
});
var UrlSpan = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("span")({
    color: "#0A7ABE",
    textDecoration: "underline",
    cursor: "pointer"
});


/***/ }),

/***/ 45629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ SimpleHeader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(80562);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Link/Link.js + 2 modules
var Link = __webpack_require__(68346);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/AppBar/AppBar.js + 1 modules
var AppBar = __webpack_require__(85050);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js
var Box = __webpack_require__(30120);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
;// CONCATENATED MODULE: ./src/components/Header/SimpleHeader.styles.ts


var RootDiv = (0,styled/* default */.Z)(AppBar/* default */.Z, {
    shouldForwardProp: function(prop) {
        return prop !== "backgroundColor";
    }
})(function(param) {
    var theme = param.theme, backgroundColor = param.backgroundColor;
    return {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        zIndex: 100,
        top: 0,
        bottom: "auto",
        height: "64px",
        padding: "0 24px",
        backgroundColor: backgroundColor || theme.palette.primary.dark,
        color: "#414046",
        boxShadow: "0px 1px 10px rgb(0 0 0 / 12%)"
    };
});
var CenteredWrapper = (0,styled/* default */.Z)(Box/* default */.Z)({
    marginTop: "4px"
});
var TitleTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "19px",
    lineHeight: "28.5px",
    letterSpacing: "0.15px",
    color: "#414046",
    textAlign: "center"
});
var LeftActionContainer = (0,styled/* default */.Z)("div")({
    position: "absolute",
    left: 24
});

// EXTERNAL MODULE: ./src/components/icons/LogoMeki.tsx
var LogoMeki = __webpack_require__(73604);
// EXTERNAL MODULE: ./src/utils/routes.ts
var routes = __webpack_require__(68139);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowBackIosNew.js
var ArrowBackIosNew = __webpack_require__(78298);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useTheme.js
var useTheme = __webpack_require__(62097);
;// CONCATENATED MODULE: ./src/components/Header/SimpleHeader.tsx









var backgroundColorMap = function(theme) {
    return {
        blue: theme.palette.primary.dark,
        white: "#fff"
    };
};
function SimpleHeader(param) {
    var _backButton = param.backButton, backButton = _backButton === void 0 ? false : _backButton, parentHandleBack = param.handleBack, _homeButton = param.homeButton, homeButton = _homeButton === void 0 ? false : _homeButton, _homeButtonColor = param.homeButtonColor, homeButtonColor = _homeButtonColor === void 0 ? "black" : _homeButtonColor, _title = param.title, title = _title === void 0 ? null : _title, _color = param.color, color = _color === void 0 ? "blue" : _color;
    var router = (0,next_router.useRouter)();
    var theme = (0,useTheme/* default */.Z)();
    var backgroundColor = backgroundColorMap(theme)[color];
    var handleBack = (0,react.useCallback)(function() {
        if (parentHandleBack) {
            parentHandleBack();
        } else if (window.history.length > 2) {
            router.back();
        } else {
            router.push((0,routes/* getRoute */.Bv)("homeLoggedIn").toString());
        }
    }, [
        router,
        parentHandleBack
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootDiv, {
        backgroundColor: backgroundColor,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftActionContainer, {
                children: backButton ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                    size: "small",
                    color: "inherit",
                    "aria-label": "back",
                    onClick: handleBack,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBackIosNew/* default */.Z, {})
                }) : !homeButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    href: (0,routes/* getRoute */.Bv)("homeLoggedIn").toString(),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoMeki/* MekiLogo */.$, {
                        height: "20px",
                        width: "auto",
                        fill: homeButtonColor
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    homeButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: (0,routes/* getRoute */.Bv)("homeLoggedIn").toString(),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CenteredWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoMeki/* MekiLogo */.$, {
                                height: "20px",
                                width: "auto",
                                fill: homeButtonColor
                            })
                        })
                    }),
                    !homeButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleTypography, {
                            children: title
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
        ]
    });
}


/***/ }),

/***/ 43354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cv": function() { return /* binding */ ErrorModal; },
/* harmony export */   "VF": function() { return /* binding */ AlertModal; }
/* harmony export */ });
/* unused harmony export ModalDialogContentText */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26993);
/* harmony import */ var _mui_material_Dialog__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1890);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29630);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(68346);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13264);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _config_environment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60031);
/*
 * File: Modal.tsx
 * Project: @inventures/react-lib
 * File Created: Wednesday, 23rd September 2020 4:10:47 pm
 * Author: Esperanza Horn (esperanza@inventures.cl)
 * -----
 * Last Modified: Wednesday, 12th July 2023 6:57:54 pm
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2020 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 










var IconContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("div")({
    position: "relative",
    height: "14px",
    width: "14px",
    marginLeft: "90%",
    marginTop: "20px"
});
var Container = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("div")({});
var DialogTitle = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "17px",
    lineHeight: "150%",
    letterSpacing: "0.15px",
    color: "#414046",
    textAlign: "center",
    marginBottom: "12px"
});
var DialogContentText = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "150%",
    letterSpacing: "-0.011em",
    textAlign: "center",
    color: "#414046",
    margin: "0px 18px 12px 18px"
});
var DialogActions = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("div", {
    shouldForwardProp: function(prop) {
        return prop !== "direction";
    }
})(function(param) {
    var direction = param.direction;
    return {
        display: "flex",
        flexDirection: direction || "column",
        alignItems: "center",
        padding: direction === "row" ? "16px" : "17px 0px",
        gap: direction === "row" ? "16px" : "0px"
    };
});
var ButtonAction = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    borderRadius: "100px",
    height: "42px",
    width: "199px",
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.15px",
    textDecoration: "none",
    textTransform: "none"
});
var Pointer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("div")({
    cursor: "pointer"
});
var ModalDialog = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_mui_material_Dialog__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
    shouldForwardProp: function(prop) {
        return prop !== "changeDialogPaper";
    }
})(function(param) {
    var changeDialogPaper = param.changeDialogPaper;
    return {
        "& .MuiDialog-paper": (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            margin: 16,
            maxWidth: 336
        }, changeDialogPaper ? {
            width: "100%",
            minHeight: 197
        } : {})
    };
});
var ModalDialogContentText = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(DialogContentText, {
    shouldForwardProp: function(prop) {
        return prop !== "alingContentLeft";
    }
})(function(param) {
    var alignContentLeft = param.alignContentLeft;
    return {
        textAlign: alignContentLeft ? "left" : "center",
        whiteSpace: "pre-line"
    };
});
function AlertModal(props) {
    var title = props.title, open = props.open, content = props.content, children = props.children, actions = props.actions, actionsDirection = props.actionsDirection, setOpen = props.setOpen, onClose = props.onClose, disableEscapeKeyDown = props.disableEscapeKeyDown, onBackdropClick = props.onBackdropClick, AlignContentLeft = props.AlignContentLeft, changeDialogPaper = props.changeDialogPaper, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(props, [
        "title",
        "open",
        "content",
        "children",
        "actions",
        "actionsDirection",
        "setOpen",
        "onClose",
        "disableEscapeKeyDown",
        "onBackdropClick",
        "AlignContentLeft",
        "changeDialogPaper"
    ]);
    var handleClose = function() {
        if (onClose) onClose();
        else if (actions.length === 1) actions[0].onActionClick();
        setOpen(false);
    };
    var haveHandleClose = (actions === null || actions === void 0 ? void 0 : actions.length) === 1 || onClose;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ModalDialog, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, otherProps), {
        open: open,
        onClose: handleClose,
        changeDialogPaper: changeDialogPaper,
        disableEscapeKeyDown: disableEscapeKeyDown,
        onBackdropClick: onBackdropClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Container, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconContainer, {
                    children: haveHandleClose && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Pointer, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            layout: "fill",
                            src: "/assets/images/home/closeicon.webp",
                            alt: "closeIcon",
                            objectFit: "contain",
                            onClick: handleClose
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DialogTitle, {
                    children: title
                }),
                content && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ModalDialogContentText, {
                    alignContentLeft: AlignContentLeft,
                    children: content
                }),
                children,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DialogActions, {
                    direction: actionsDirection,
                    children: actions === null || actions === void 0 ? void 0 : actions.map(function(action, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonAction, {
                            onClick: action.onActionClick,
                            color: "primary",
                            variant: action.variant,
                            children: action.text
                        }, index);
                    })
                })
            ]
        })
    }));
}
function ErrorModal(props) {
    var open = props.open, title = props.title, description = props.description, handleBack = props.handleBack, whatsappText = props.whatsappText;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AlertModal, {
        title: title,
        open: open,
        setOpen: function() {},
        disableEscapeKeyDown: true,
        disableBackdropClick: true,
        actions: [
            {
                text: "Aceptar",
                onActionClick: handleBack,
                variant: "contained"
            }, 
        ],
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ModalDialogContentText, {
            children: [
                description,
                ", intenta nuevamente o",
                " ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    target: "_blank",
                    href: "https://api.whatsapp.com/send?phone=".concat(_config_environment__WEBPACK_IMPORTED_MODULE_3__/* .PHONE_NUMBER.CLEAN */ .UE.CLEAN, "&text=").concat(encodeURI(whatsappText)),
                    children: "cont\xe1ctanos para recibir ayuda"
                })
            ]
        })
    });
}


/***/ }),

/***/ 39425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ SEOHead; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50930);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2962);
/* harmony import */ var _siteMetaData_json__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64507);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _config_environment__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60031);










var BASE_IMAGES = [
    {
        url: "https://d1zphfo9y2yvu9.cloudfront.net/meta/Meki.jpg",
        type: "image/jpg",
        width: 1200,
        height: 630
    },
    {
        url: "https://d1zphfo9y2yvu9.cloudfront.net/meta/1200x630.png",
        type: "image/png",
        width: 1200,
        height: 630
    },
    {
        url: "https://d1zphfo9y2yvu9.cloudfront.net/meta/256x256.jpg",
        type: "image/jpg",
        width: 256,
        height: 256
    },
    {
        url: "https://d1zphfo9y2yvu9.cloudfront.net/meta/256x256.png",
        type: "image/png",
        width: 256,
        height: 256
    }, 
];
function SEOHead(props) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var description = props.description, title = props.title, customImage = props.customImage, canonical = props.canonical;
    var site = _siteMetaData_json__WEBPACK_IMPORTED_MODULE_4__/* .landing */ ._;
    var image = customImage;
    var metaDescription = description ? description : site.description;
    var metaTitle = title || site.title;
    var headData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        title: metaTitle,
        description: metaDescription
    }, canonical ? {
        canonical: canonical
    } : {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_3__/* .NextSeo */ .PB, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, headData), {
                openGraph: {
                    title: metaTitle,
                    description: metaDescription,
                    type: site.type,
                    url: "".concat(_config_environment__WEBPACK_IMPORTED_MODULE_6__/* .BASE_URL */ ._n).concat(router.asPath),
                    images: [
                        image && {
                            url: image.url,
                            width: Number(image.width.replace("px", "")),
                            height: Number(image.height.replace("px", "")),
                            alt: metaTitle
                        }, 
                    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(BASE_IMAGES)).filter(Boolean)
                },
                additionalMetaTags: [
                    {
                        name: "viewport",
                        content: site.scale
                    }
                ]
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    charSet: site.charSet
                })
            })
        ]
    });
}


/***/ }),

/***/ 82688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ CreateAuthCodeMutation; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68921);
/*
 * File: createAuthCode.ts
 * Project: meki
 * File Created: Monday, 12th December 2022 10:51:29 am
 * Author: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Last Modified: Wednesday, 21st December 2022 6:13:02 pm
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2022 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation CreateAuthCode($params: CreateAuthCodeParams!) {\n    createAuthCode(params: $params) {\n      msg\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var CreateAuthCodeMutation = function() {
    return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
};


/***/ }),

/***/ 514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bd": function() { return /* binding */ CodeHelperContainer; },
/* harmony export */   "Mq": function() { return /* binding */ LoaderComponentContainer; },
/* harmony export */   "Nw": function() { return /* binding */ CodeInput; },
/* harmony export */   "S0": function() { return /* binding */ IconListItemText; },
/* harmony export */   "Sc": function() { return /* binding */ IncorrectCodeTypography; },
/* harmony export */   "fD": function() { return /* binding */ GreyOverlay; },
/* harmony export */   "nZ": function() { return /* binding */ CodeHelperButton; },
/* harmony export */   "rc": function() { return /* binding */ CheckContainer; },
/* harmony export */   "vt": function() { return /* binding */ AskDataTypography; },
/* harmony export */   "xE": function() { return /* binding */ CenterCodeInput; }
/* harmony export */ });
/* unused harmony export InlinePhoneContainer */
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13264);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29630);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61702);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26993);
/* harmony import */ var react_code_input__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38279);
/* harmony import */ var react_code_input__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_code_input__WEBPACK_IMPORTED_MODULE_0__);



var AskDataTypography = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    marginBottom: "8px",
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.15px",
    color: "#414046",
    textAlign: "left"
});
var IconListItemText = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    fontSize: "32px",
    marginRight: "10px",
    maxWidth: "16px"
});
var InlinePhoneContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div")({
    display: "inline-block",
    marginRight: "5px"
});
var CenterCodeInput = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div")({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: "4px"
});
var CodeInput = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((react_code_input__WEBPACK_IMPORTED_MODULE_0___default()))(function(prop) {
    return {
        input: {
            display: "flex",
            flexDirection: "row",
            textAlign: "center",
            justifyContent: "center",
            fontFamily: "Poppins",
            margin: "4px 3px",
            width: "38px",
            borderRadius: "4px",
            fontSize: "20px",
            lineHeight: "23px",
            height: "50px",
            backgroundColor: "#FFFFFF",
            color: "#414046 !important",
            border: prop.isValid ? "grey solid 1px" : "0.8px solid red !important",
            "&:focus": {
                border: "1px solid #0A7ABE !important",
                outline: "#c8c8c8 solid 1px"
            },
            "&:nth-child(1)": {
                order: "1 !important"
            },
            "&:nth-child(2)": {
                order: "2 !important"
            },
            "&:nth-child(3)": {
                order: "3 !important"
            },
            "&:nth-child(4)": {
                order: "5 !important"
            },
            "&:nth-child(5)": {
                order: "6 !important"
            },
            "&:nth-child(6)": {
                order: "7 !important"
            },
            "&:nth-child(7)": {
                order: "8 !important",
                display: "none !important"
            }
        },
        display: "flex !important",
        alignItems: "center !important",
        justifyContent: "center !important",
        "&::after": {
            content: '""',
            margin: "0px 0px !important",
            width: "15px !important",
            height: "3px !important",
            backgroundColor: "withe !important",
            order: "4 !important"
        }
    };
});
var CodeHelperContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div")({
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    width: "fit-content",
    margin: "0 auto"
});
var CodeHelperButton = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
    var disabled = param.disabled;
    return {
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "16px",
        textAlign: "center",
        letterSpacing: "0.15px",
        textDecoration: "none",
        color: disabled ? "#AFAFAF" : "#0A7ABE",
        textTransform: "none"
    };
});
var IncorrectCodeTypography = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.15px",
    color: "red",
    textAlign: "center",
    minHeight: "24px"
});
var LoaderComponentContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div")({
    position: "absolute",
    top: "40vh",
    left: "calc(50vw - 150px)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    alignItems: "center",
    height: "20vh",
    paddingTop: "5vh",
    paddingBottom: "5vh",
    width: 300,
    borderRadius: "10px",
    backgroundColor: "#FFFFFF",
    zIndex: 4002
});
var GreyOverlay = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div")({
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 4001
});
var CheckContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div")({
    display: "flex",
    flexDirection: "column",
    marginBottom: "0px",
    alignItems: "center",
    justifyContent: "center",
    justifyItems: "center"
});



/***/ }),

/***/ 56665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ BiometricApi; },
/* harmony export */   "W": function() { return /* binding */ UserApi; }
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89644);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _config_environment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60031);


var BiometricApi = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: "".concat(_config_environment__WEBPACK_IMPORTED_MODULE_1__/* .GRAPHQL_URI */ .r8, "/biometric"),
    headers: _config_environment__WEBPACK_IMPORTED_MODULE_1__/* .API_SECRET */ .JJ ? {
        secret: _config_environment__WEBPACK_IMPORTED_MODULE_1__/* .API_SECRET */ .JJ
    } : {}
});
var UserApi = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: "".concat(_config_environment__WEBPACK_IMPORTED_MODULE_1__/* .GRAPHQL_URI */ .r8, "/client/user"),
    headers: _config_environment__WEBPACK_IMPORTED_MODULE_1__/* .API_SECRET */ .JJ ? {
        secret: _config_environment__WEBPACK_IMPORTED_MODULE_1__/* .API_SECRET */ .JJ
    } : {}
});


/***/ }),

/***/ 93213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ browserIsValidForBiometric; }
});

// EXTERNAL MODULE: ../../node_modules/ua-parser-js/src/ua-parser.js
var ua_parser = __webpack_require__(46353);
var ua_parser_default = /*#__PURE__*/__webpack_require__.n(ua_parser);
;// CONCATENATED MODULE: ./src/utils/browserInfo.ts

var getBrowserInfo = function() {
    var userAgent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : navigator.userAgent;
    var parser = new (ua_parser_default())(userAgent);
    var browser = parser.getBrowser();
    var os = parser.getOS();
    return {
        name: browser.name,
        version: browser.version,
        osName: os.name
    };
};

// EXTERNAL MODULE: ./node_modules/react-device-detect/main.js
var main = __webpack_require__(59359);
;// CONCATENATED MODULE: ./src/utils/validators/biometricBrowserValidator.ts


var invalidBrowsers = [
    {
        name: "Chrome Mobile",
        osName: "Android",
        version: 125
    },
    {
        name: "Chrome",
        version: 85
    },
    {
        name: "Edge",
        version: 85
    },
    {
        name: "Safari",
        version: 14
    },
    {
        name: "Firefox",
        version: 79
    },
    {
        name: "Opera",
        version: 71
    }, 
];
var browserIsValidForBiometric = function() {
    var browser = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getBrowserInfo();
    if (browser.name === "Chrome Mobile" && browser.osName == "Android" && parseInt(browser.version) < 125) {
        return false;
    }
    if (invalidBrowsers.some(function(invalidBrowser) {
        return invalidBrowser.name === browser.name && (!invalidBrowser.version || parseInt(browser.version) < invalidBrowser.version);
    }) || !main/* isMobile */.tq) {
        return false;
    }
    return true;
};


/***/ }),

/***/ 64507:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"_":{"title":"Meki · Farmacia a domicilio","description":"Todo lo que necesitas, hasta los medicamentos difíciles. Precios bajos y convenio con Cenabast. Despacho GRATIS en Santiago por compras sobre $35.000.","author":"@mimeki","type":"website","charSet":"utf-8","scale":"width=device-width, initial-scale=1","image":{"url":"https://meki-public.s3.us-east-2.amazonaws.com/meta/Meki.jpg","type":"image/jpg","width":"1200","height":"630"},"imageCart":{"url":"https://meki-public.s3.us-east-2.amazonaws.com/meta/metadataCarrito.png","type":"image/png","width":"256","height":"256"}}}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2962,7536,1613,6353,1126,8836,9774,2888,179], function() { return __webpack_exec__(54961), __webpack_exec__(28262); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);